<template>
  <div>
    <!-- Navbar -->
    <nav class="contenedor_nav">
        <!-- <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" @click="sbMenuClick">
          <i class="fas fa-bars main-sidebar"></i></a>  
        </li> -->

      <div class="elemento_nav elemento_nombre">
        <i class="fa fa-user"></i>
        <p class="formatoLabelMenu nav_nombre">{{ this.nombres }}</p>
      </div>

        <!-- <li class="nav-item d-none d-sm-inline-block" style="width: 12rem">
          <a class="nav-link"> <i class="fa fa-user"> </i><i class=" ml-2 formatoLabelMenu "> {{ this.nombres }}
            </i></a>
        </li> -->

      <div class="contenedor_elementos">

        <!-- Notificación -->
        <div ref="contenedorNotificaciones" 
        class="elemento_notificacion seccion elemento_nav campana_notificacion">
          <div class="contenedor_campana" @click="toggleMensajes">
            <span class="notificacion_numero">{{ mensajesNoLeidos.length }}</span>
            <i class="fa-solid fa-bell i_campana"></i>
          </div>
          
          <!-- Mensajes pendientes de leer -->
          <div class="contenedor_mensajes animar" v-if="mostrarMensajes">
            <div class="contenedor_grupo_mensajes">
              <div class="grupo_mensajes">
                <div v-for="dato in mensajesNoLeidos" :key="dato.notificacionID" class="mensaje">
                  <div class="not_cabecera">
                    <div class="not_fecha">
                      {{ dato.fechaMensaje | formatDateTime }}
                    </div>
                    <div class="not_leido" v-if="dato.leido === false">
                      <p class="marcar_leido" @click="marcarLeido(dato.notificacionID)">Marcar como leido</p>
                    </div>
                  </div>
                  <div class="not_mensaje">
                    {{ dato.mensaje }}
                  </div>
                </div>
                <div v-if="mensajesNoLeidos.length === 0" class="sin_resultados">
                  <p>No hay mensajes disponibles</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="elemento_nav seccion" @click="sbConsultarInformacion">
          <i class="fa-solid fa-address-book icono_m"></i>
          <div class="formatoLabelMenu texto_menu">Perfil Facturación 
          </div>
        </div>

        <div class="elemento_nav seccion"  @click="sbMostrarPass">
          <i class="fa-solid fa-key icono_m"></i> 
          <div class="formatoLabelMenu texto_menu">Cambiar Contraseña
          </div>
        </div>
      </div>

      <!-- <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link"><i class="fa fa-user-group "></i> <i class=" ml-2 formatoLabelMenu"
              @click="sbConsultarInformacion"> Perfil Facturacion </i></a>
        </li>

        <li class="nav-item">
          <a class="nav-link"><i class="fa fa-lock "></i> <i class=" ml-1 formatoLabelMenu" @click="sbMostrarPass">
              Cambiar Contraseña </i></a>
        </li>
      </ul> -->
    </nav>

    <div class="contenedor_perfilFacturacion">
      <!-- B-modal Perfil de Facturación -->
      <b-modal size="md" title="Perfil Facturación" 
        v-model="modalPerfil" hide-footer centered 
        dialog-class="contenedor_modal"
        header-class="contenido_cabecera"
        content-class="contenido_modal"
      > 
        <template #modal-title>
          <div class="header_modal">
            <i class="fas fa-file-invoice"></i>
            <span>Perfil de Facturación</span>
          </div>
        </template>
        <b-container>
          <b-form-group class="contenedor_grupo" label="RFC:" label-for="rfcInput">
            <b-form-input class="grupo_input" size="sm" id="rfcInput"
              v-model="perfilFacturacion.rfc" type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group class="contenedor_grupo" label="Razon Social:" label-for="razonInput">
            <b-form-input class="grupo_input" size="sm" id="razonInput"
              v-model="perfilFacturacion.nombre" type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group class="contenedor_grupo" label="Calle:" label-for="calleInput">
            <b-form-input class="grupo_input" size="sm" id="calleInput"
              v-model="perfilFacturacion.calle" type="text">
            </b-form-input>
          </b-form-group>

          <div class="contenedor_dividido">
            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="Codigo Postal:" label-for="cpInput">
                <b-form-input class="grupo_input" size="sm" id="cpInput"
                  v-model="perfilFacturacion.codigoPostal" type="text">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="No. Exterior:" label-for="noExtInput">
                <b-form-input class="grupo_input" size="sm" id="noExtInput"
                  v-model="perfilFacturacion.noExterior" type="text">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="No. Interior:" label-for="noIntInput">
                <b-form-input class="grupo_input" size="sm" id="noIntInput"
                  v-model="perfilFacturacion.noInterior" type="text">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="contenedor_dividido">
            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="Colonia:" label-for="coloniaInput">
                <b-form-input class="grupo_input" size="sm" id="coloniaInput"
                  v-model="perfilFacturacion.colonia" type="text">
                </b-form-input>
              </b-form-group>

            </div>
            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="Localidad:" label-for="localidadInput">
                <b-form-input class="grupo_input" size="sm" id="localidadInput"
                  v-model="perfilFacturacion.localidad" type="text">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <div class="contenedor_dividido">
            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="Ciudad:" label-for="ciudadInput">
                <b-form-input class="grupo_input" size="sm" id="ciudadInput"
                  v-model="perfilFacturacion.ciudad" type="text">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="Estado:" label-for="estadoInput">
                <b-form-input class="grupo_input" size="sm" id="estadoInput"
                  v-model="perfilFacturacion.estado" type="text">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <b-form-group class="contenedor_grupo" label="Regimen:" label-for="idRegimen">
            <b-form-select v-model="perfilFacturacion.regimenFiscalID" :options="datosRegimen" id="idRegimen"
              class="diseño_select">
            </b-form-select>
          </b-form-group>

          <div class="contenedor_dividido">
            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="Nombre Usuario:" label-for="nombreInput">
                <b-form-input class="grupo_input" size="sm" id="nombreInput" type="text"
                  v-model="perfilFacturacion.nombreUsuario" maxlength="40">
                </b-form-input>
              </b-form-group>
            </div>

            <div class="dividido">
              <b-form-group class="contenedor_grupo" label="Correo:" label-for="correoInput">
                <b-form-input class="grupo_input" size="sm" id="correoInput" type="text"
                  v-model="perfilFacturacion.correo" maxlength="90">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <button class="btnAceptar1" type="button" @click="sbActualizarPerfil">Actualizar</button>

        </b-container>
      </b-modal>
    </div>

    <!-- B-modal Cambiar Contraseña -->
    <b-modal size="sm" title="Cambiar Contraseña" 
      v-model="modalPass" hide-footer centered
      dialog-class="con_contra"
      header-class="contenido_cabecera"
      content-class="contenido_modal"
    >
      <template #modal-title>
        <div class="header_modal">
          <i class="fa-solid fa-key"></i>
          <span>Cambiar Contraseña</span>
        </div>
      </template>
      <b-container>
        <div class="contenedor_dividido">
          <b-form-group class="contenedor_grupo" label="Nueva:" label-for="passNuevoInput">
            <div class="contenedor_contra">
              <b-form-input class="grupo_input" id="passNuevoInput" :type="showPasswordNuevo ? 'text' : 'password'"
                v-model="passwordActualizado" maxlength="8">
              </b-form-input> 

              <div class="contenedor_eye" @click="sbMostrarPassNuevo" >
                <span v-if="showPasswordNuevo" class="fas fa-eye-low-vision"></span>
                <i v-else class="fas fa-eye"></i>
              </div>
            </div>
          </b-form-group>
      </div>

      <div class="contenedor_dividido">
        <b-form-group class="contenedor_grupo" label="Confirmar:" label-for="passConfirmarInput">

          <div class="contenedor_contra">
            <b-form-input class="grupo_input" id="passConfirmarInput" :type="showPasswordConfirmar ? 'text' : 'password'"
              v-model="passwordConfirmacion" maxlength="8">
            </b-form-input>

            <div class="contenedor_eye" @click="sbMostrarPassConfirmar" >
              <span v-if="showPasswordConfirmar" class="fas fa-eye-low-vision"></span>
              <i v-else class="fas fa-eye"></i>
            </div>
          </div>
        </b-form-group>
      </div>

      <button class="btnAceptar1" type="button" @click="sbActualizarPass">Actualizar</button>
      </b-container>
    </b-modal>

  </div>
</template>

<script>
const $ = require('jquery')
// Lo declaramos globalmente
window.$ = $

import servicioCliente from '../services/servicioCliente'
import MenuLateral from './menuLateral.vue';
export default {
  data() {
    return {
      modalPerfil: false,
      modalPass: false,
      numeroCliente: '',
      usuario: '',
      password: '',
      passwordActualizado: '',
      passwordConfirmacion: '',
      nombres: '',
      clienteID: 0,
      showPasswordNuevo:false,
      showPasswordConfirmar:false,
      datosPerfilFacturacion: [],
      datosRegimen: [
        { value: null, text: 'Seleccionar' },
        { value: '1', text: 'GENERAL DE LEY PERSONAS MORALES' },
        { value: '2', text: 'PERSONAS MORALES CON FINES NO LUCRATIVOS' },
        { value: '3', text: 'SUELDOS Y SALARIOS E INGRESOS ASIMILADOS A SALARIOS' },
        { value: '4', text: 'ARRENDAMIENTO' },
        { value: '5', text: '	REGIMEN DE ENAJENACION O ADQUISICION DE BIENES' },
        { value: '6', text: '	DEMAS INGRESOS' },
        { value: '7', text: '	RESIDENTES EN EL EXTRANJERO SIN ESTABLECIMIENTO PERMANENTE EN MEXICO' },
        { value: '8', text: '	INGRESOS POR DIVIDENDOS (SOCIOS Y ACCIONISTAS)' },
        { value: '9', text: '	PERSONAS FISICAS CON ACTIVIDADES EMPRESARIALES Y PROFESIONALES' },
        { value: '10', text: '	INGRESOS POR INTERESES' },
        { value: '11', text: '	REGIMEN DE LOS INGRESOS POR OBTENCION DE PREMIOS' },
        { value: '12', text: '	SIN OBLIGACIONES FISCALES' },
        { value: '13', text: '	SOCIEDADES COOPERATIVAS DE PRODUCCION QUE OPTAN POR DIFERIR SUS INGRESOS' },
        { value: '14', text: '	INCORPORACION FISCAL' },
        { value: '15', text: '	ACTIVIDADES AGRICOLAS' },
        { value: '16', text: '	OPCIONAL PARA GRUPOS DE SOCIEDADES' },
        { value: '17', text: '	COORDINADOS' },
        { value: '18', text: '	REGIMEN DE LAS ACTIVIDADES EMPRESARIALES CON INGRESOS A TRAVES DE PLATAFORMAS TECNOLOGICAS' },
        { value: '19', text: '	REGIMEN SIMPLIFICADO DE CONFIANZA' },
      ],
      perfilFacturacion: {
        rfc: '',
        nombre: '',
        numeroCliente: '',
        usuario: '',
        pass: '',
        clienteID: 0,
        calle: '',
        colonia: '',
        ciudad: '',
        codigoPostal: '',
        noInterior: '',
        noExterior: '',
        localidad: '',
        estado: '',
        regimenFiscalID: 1,
        descripcion: '',
        nombreUsuario: '',
        correo: ''
      },

      mensajesNoLeidos: [],
      mostrarMensajes: false,
      cerrandoMensajes: false
    }
  },
  mounted() {
    this.usuario = localStorage.getItem("usuario")
    this.numeroCliente = localStorage.getItem("numeroCliente")
    this.clienteID = localStorage.getItem("clienteID")
    this.password = localStorage.getItem("pass")
    this.nombres = localStorage.getItem("nombres")

    this.mensajesNoLeidosCliente()
    document.addEventListener('click', this.cerrarMensajes)

    this.sbTimer();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.cerrarMensajes)
  },
  functiontwo(x) {
    x = document.getElementById("navbartoggler");
    x.classList.toggle("menuTop");
  },
  methods:
  {
    async sbActualizarPerfil() {
      this.mostrarMensajes = false
      var mensaje = ''

      this.perfilFacturacion.clienteID = this.clienteID
      this.perfilFacturacion.numeroCliente = this.numeroCliente
      this.perfilFacturacion.pass = this.password
      this.perfilFacturacion.usuario = this.usuario


      var respuesta = await servicioCliente.guardarPerfilFacturacion(this.perfilFacturacion)
      if (respuesta.value == true) {
        mensaje = 'Perfil Actualizado.'
        this.$msg.success(mensaje)
        this.modalPerfil = false
      }
      else {

        mensaje = 'No se pudieron guardar los cambios.'
        this.$msg.error(mensaje)

      }
    },

    sbMostrarPass() {
      this.passwordActualizado = ""
      this.passwordConfirmacion = ""
      this.modalPass = true
    },

    sbMostrarPassNuevo(){
      if (this.showPasswordNuevo)
      {this.showPasswordNuevo = false}
      else{this.showPasswordNuevo = true}
    },
    
    sbMostrarPassConfirmar(){
      if (this.showPasswordConfirmar)
      {this.showPasswordConfirmar = false}
      else{this.showPasswordConfirmar = true}
    },

    sbMenuClick() {
      var menu = MenuLateral.getElementById("aside")
      menu.classList.toggle('active')
    },

    async sbActualizarPass() {
      this.mostrarMensajes = false
      var mensaje = ''

      if (this.passwordActualizado.toString().trim() == "") {
        mensaje = "La nueva contraseña debe de tener un valor. "
        this.$msg.warning(mensaje)
        return
      }

      if (this.passwordConfirmacion.toString().trim() == "") {
        mensaje = 'La contraseña a confirmar debe de tener un valor.'
        this.$msg.warning(mensaje)
        return
      }

      if (this.passwordActualizado.toString().trim() != this.passwordConfirmacion.toString().trim()) {
        mensaje = 'No coinciden las contraseñas.'
        this.$msg.warning(mensaje)
        return
      }

      this.perfilFacturacion.clienteID = this.clienteID
      this.perfilFacturacion.numeroCliente = this.numeroCliente
      this.perfilFacturacion.pass = this.passwordActualizado
      this.perfilFacturacion.usuario = ''

      var respuesta = await servicioCliente.guardarUsuario(this.perfilFacturacion)
      if (respuesta.value == true) {
        mensaje = 'Perfil Actualizado.'
        localStorage.pass = this.passwordActualizado
        this.$msg.success(mensaje)
        this.modalPass = false
      }
      else {

        mensaje = 'No se pudieron guardar los cambios.'
        this.$msg.error(mensaje)

      }
    },

    async sbConsultarInformacion() {

      var respuestaDatos = await servicioCliente.datosClientes(this.usuario, this.password)

      this.datosPerfilFacturacion = respuestaDatos.data

      this.perfilFacturacion = {
        rfc: this.datosPerfilFacturacion[0].rFC,
        nombre: this.datosPerfilFacturacion[0].nombre,
        numeroCliente: this.numeroCliente,
        usuario: this.usuario,
        pass: this.password,
        clienteID: this.clienteID,
        calle: this.datosPerfilFacturacion[0].calle,
        colonia: this.datosPerfilFacturacion[0].colonia,
        ciudad: this.datosPerfilFacturacion[0].ciudad,
        codigoPostal: this.datosPerfilFacturacion[0].codigoPostal,
        noInterior: this.datosPerfilFacturacion[0].noInterior,
        noExterior: this.datosPerfilFacturacion[0].noExterior,
        localidad: this.datosPerfilFacturacion[0].localidad,
        estado: this.datosPerfilFacturacion[0].estado,
        regimenFiscalID: this.datosPerfilFacturacion[0].regimenFiscalID,
        descripcion: this.datosPerfilFacturacion[0].descripcion,
        correo: this.datosPerfilFacturacion[0].email,
        nombreUsuario: this.datosPerfilFacturacion[0].nombres,

      }
      this.modalPerfil = true
    },

    //Obtener mensajes sin leer
    async mensajesNoLeidosCliente(){
      try{
        const payload={
          ClienteID:this.clienteID
        };

        const result = await servicioCliente.consultarNotificaciones(2,payload);
        this.mensajesNoLeidos = result.data;
        
      }catch(error){
        this.$msg.error("Error al marcar el mensaje como leido");
      }
    },

    //Método para marcar como leido
    async marcarLeido(notificacionID){
      try{
        const payload={
          NotificacionID: notificacionID
        };
        
        const result = await servicioCliente.consultarNotificaciones(3,payload);
        
        if(result.value != true){
          this.$msg.error(result.message || "Error al marcar como leido");
          return;
        }

        //Cambiar visualmente en la lista
        const notificacion = this.mensajesNoLeidos.find(
          m => m.notificacionID === notificacionID
        );

        if(notificacion){
          notificacion.leido = true
        }
        
        this.mensajesNoLeidosCliente();
      }
      catch(error){
        this.$msg.error("Error al marcar el mensaje como leido");
      }
    },

    toggleMensajes() {
      this.mostrarMensajes = !this.mostrarMensajes
    },

    cerrarMensajes(event) {
      const contenedor = this.$refs.contenedorNotificaciones
      if (contenedor && !contenedor.contains(event.target)
      ) {
        this.mostrarMensajes = false
      }
    },

    sbTimer() {
      this.intervalId =  setInterval(() => {
        this.mensajesNoLeidosCliente()
      }, 4000)
    },

  }

}
</script>

<style scoped>
.contenedor_dividido{
  justify-content: center;
}

.formatoLabelMenu {
  font-size: 12px;
  font-weight: 500;
}

.elemento_nombre,
.formatoLabelMenu.nav_nombre{
  font-size: 14px;
  margin: 0;
  cursor: auto;
}

.contenedor_perfilFacturacion{
  display: flex;
  justify-content: center;
}

.btnAceptar1{
  width: 100%;
}

.texto_menu{
  overflow-wrap: break-word;
}

/* Notificaciones */
.elemento_notificacion{
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 10px;
}

.elemento_notificacion.seccion{
  cursor: auto;
}

.elemento_notificacion:hover{
  background: rgba(255,255,255,.05);
}

.contenedor_mensajes{
  position: absolute;
  top: 45px;
  right: -50px;
  /* right: -220px; */
  padding: 10px 15px; 
  z-index: 9999;
  width: 400px;
  max-height: 500px;
  overflow-y: auto;
  /* height: 400px; */
  background: white;
  border: 1px solid #dfe3f0;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,.15);
  cursor: auto;
}

.contenedor_grupo_mensajes{
  padding: 5px;
  overflow-y: auto;
  max-height: 350px;
}

.not_cabecera,
.not_mensaje{
  font-size: 12px;
}

.animar{
  animation: aparecer 0.35s ease;
}
@keyframes aparecer{
  from{
    opacity: 0;
    transform: translateY(-10px);
  }
  to{
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes desaparecer{
  from{
    opacity: 1;
    transform: translateY(0);
  }
  to{
    opacity: 0;
    transform: translateY(-10px);
  }
}

/* ========================= */
/* Responsivo Móvil */
/* ========================= */

@media screen and (max-width: 768px){

  /* Navbar */
  .contenedor_nav{
    height: auto;
    margin-left: 55px;
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
    padding: 2px 12px;
  }

  .elemento_nombre{
    width: 100%;
    justify-content: center;
    padding: 10px;
    border-radius: 12px;
    background: rgba(255,255,255,.08);
  }

  .nav_nombre{
    font-size: 12px !important;
  }

  .contenedor_elementos{
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    flex-direction: row;
    align-items: stretch;
    gap: 8px;
    padding: 6px 0;
  }

   .campana_notificacion{
    order: 3;
    margin-left: auto;
  }

  .seccion{
    width: 100%;
    padding: 4px 12px;
    border-radius: 12px;
    background: rgba(255,255,255,.05);
  }

  .elemento_nav{
    gap: 12px;
  }

  .texto_menu{
    width: 100%;
    font-size: 11px;
  }

  .nav_nombre{
    text-align: center;
    word-break: break-word;
  }

  /* Modal */
  .contenedor_modal{
    max-width: 95% !important;
    margin: 10px auto;
  }

  .con_contra{
    max-width: 95% !important;
  }

  .contenedor_canjear{
    max-width: 95% !important;
  }

  .contenido_modal{
    border-radius: 18px;
  }

  .contenido_cabecera{
    padding: 12px;
  }

  .header_modal{
    font-size: 15px;
  }

  .header_modal i{
    font-size: 16px;
  }

  /* Inputs */
  .contenedor_dividido{
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }

  .dividido{
    width: 100%;
  }

  .grupo_input{
    width: 100%;
    font-size: 12px;
  }

  .diseño_select{
    width: 100%;
    font-size: 12px;
  }

  .contenedor_grupo{
    margin-bottom: 12px;
  }

  /* Constraseña */
  .contenedor_contra{
    width: 100%;
  }

  .contenedor_eye{
    min-width: 42px;
    height: 42px;
  }

  /* Botón */
  .btnAceptar1{
    margin-top: 10px;
    /* padding: 12px; */
    border-radius: 12px;
    font-size: 14px;
  }

  .contenedor_mensajes{
    width: calc(100vw - 30px);
    max-width: 350px;
    right: 0;
    padding: 12px;
  }

}

/* ========================= */
/* Responsivo celular chico */
/* ========================= */

@media screen and (max-width: 480px){

  .contenedor_nav{
    padding: 10px;
    margin-left: 55px;
  }

  .formatoLabelMenu{
    font-size: 12px;
  }

  .nav_nombre{
    font-size: 13px;
  }

  .elemento_nav{
    padding: 10px;
  }

  .header_modal{
    font-size: 14px;
  }

  .grupo_input{
    font-size: 12px;
  }

  .diseño_select{
    font-size: 12px;
  }

  .contenedor_mensajes{
    width: calc(100vw - 20px);
    right: 0;
    max-width: 300px;
    top: 65px;
  }
}

.sin_resultados p{
  color: #000;
  margin-bottom: 0;
  font-size: 12px;
}
</style>